// kept only for reference
// const unit = 2;
// const ico8 = unit * 4 + 'px'; // xsmall
// const ico10 = unit * 5 + 'px'; // small
// const ico12 = unit * 6 + 'px'; // regular
// const ico18 = unit * 9 + 'px'; // large

export const defaultFontThemeProperties = {
  fontFamily: 'Rubik',
  unit: 1.2,
  unitScale: 1,
  unitScaleStartingPoint: 0.2,
};

export default function buildFont(
  fontThemeProperties = defaultFontThemeProperties
) {
  return {
    fontFamily: fontThemeProperties.fontFamily,
    base: fontThemeProperties.unit + "rem", // 12px | 1.2rem
    small:
      fontThemeProperties.unit -
      fontThemeProperties.unitScaleStartingPoint +
      "rem", // 10px | 1rem
    xsmall:
      fontThemeProperties.unit -
      fontThemeProperties.unitScaleStartingPoint * 2 +
      "rem", // 8px | 0.8rem
    large:
      fontThemeProperties.unit +
      fontThemeProperties.unitScaleStartingPoint * 3 +
      "rem", // 18px | 1.8rem
    lineHeight: {
      base: 1.33,
    },
    fontWeights: {
      light: 300,
      regular: 400,
      bold: 700,
      black: 900,
    },
    fontSizes: {
      font10: "1rem",
      font12: "1.2rem",
      font14: "1.4rem",
      font15: "1.5rem",
      font16: "1.6rem",
      font18: "1.8rem",
      font20: "2rem",
      font22: "2.2rem",
      font24: "2.4rem",
      font26: "2.6rem",
      font28: "2.8rem",
      font30: "3rem",
      font32: "3.2rem",
    },
    custom: (
      multiplier: 14 | 16 | 20 | 22 | 24 // 14 - 14px | 16 - 16px | 20px 22px 24px
    ) => multiplier * 0.1 + "rem",
  };
}
